import React from "react";
import styled from "styled-components";

const CookieWrapper = styled.div`
  background: #252e39;
  display: none;
  position: fixed;bottom: 0;left: 0;width: 100%;padding: 0;margin: 0;z-index: 999;padding: 1em 1.8em;box-sizing: border-box;
  box-shadow: 1px 1px 20px rgba(0,0,0,.4);
  main, aside {display: flex;flex: 1 1 auto;justify-content: flex-end;align-items: center;}
  h3,a {display: inline; padding: 0 0 0 8px;}
  h3 {background: transparent;padding: 0;font-size: 16px;color: white;font-weight: 400;text-transform: none;}
  a {text-decoration: underline;font-size: 16px;color: white;font-weight: 400;text-transform: none;}
  main {justify-content: flex-start;background-image: none;}
  aside {justify-content: flex-end;text-align: center;}
  button {background: #14a7d0;color: white;border: none;padding: 1em 1.2em;cursor: pointer;font-size: 16px;color: white;font-weight: 470;white-space: nowrap;text-transform: none;}
  .transparent {background: transparent;font-weight: 300;}
  @media screen and (max-width: 500px) {
    display: none;
    flex-wrap: wrap;
    main,aside {
      flex: 0 0 100%;
      text-align: center;
      justify-content: center;
    }
    a {
      width: 100%;
      display: block;
    }
    aside {
      padding: 20px 0 0 0;
    }
  }
`;

export default CookieWrapper;



// WEBPACK FOOTER //
// ./src/styled-components/CookieWrapper.js